import React from 'react';
import T from 'prop-types';

import ProgressBar from '../../../../components/HorizontalBars/ProgressBar';
import { numberToPercentage } from '../../../../utils/formatter';

const Row = ({ label, percentage }) => (
  <div className="publisher_page_monetization__bar_row d-flex align-items-center gap-xxs">
    <span className="publisher_page_monetization__bar_label text-bold">{label}</span>
    <span className="publisher_page_monetization__bar_percentage text-quiet">
      {numberToPercentage(percentage * 100, { precision: 1, strip_insignificant_zeros: true })}
    </span>
    <ProgressBar percentage={percentage * 100} showBarOnly barWidth={92} />
  </div>
);

Row.propTypes = {
  label: T.string.isRequired,
  percentage: T.number,
};

const MonetizationBars = ({ data }) => (
  <div className="publisher_page_monetization__bars">
    <Row label="IAP" percentage={data.iap_percentage} />
    <Row label="PAID" percentage={data.downloads_percentage} />
  </div>
);

MonetizationBars.propTypes = {
  data: T.shape({
    iap_percentage: T.number,
    downloads_percentage: T.number,
  }).isRequired,
};

export default MonetizationBars;
